import { useRef } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useForm } from "react-hook-form";
import emailjs from 'emailjs-com';
import Zoom from 'react-reveal/Zoom';
import { toast } from 'react-toastify';
import './ApplySection.css';

function ApplySection() {
    const formObj = useRef();

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    var templateParams = {
        name: '',
        email: '',
        phoneNumber: '',
        age: ''
    };

    const onSubmit = (data) => {
        templateParams.name = data.name;
        templateParams.email = data.email;
        templateParams.phoneNumber = data.phoneNumber;
        templateParams.age = data.age;
        emailjs.send("service_sqkbufh", "template_a2ate55", templateParams, "user_aQidpFS7FuUnB9x90N71z")
            .then(function (response) {
                formObj.current.reset();
                toast.success("Success!");
                console.log('SUCCESS!', response.status, response.text);
            }, function (error) {
                formObj.current.reset();
                toast.error("Something went wrong. Please email me at danny5733@gmail.com.");
                console.log('FAILED...', error);
            });
        console.log(data);
    }

    return (
        <div id="apply-section">
            <Container fluid>
                <Row>
                    <Col lg={12} className="apply-col">
                        <Zoom>
                            <h2 id="apply-title">APPLY NOW</h2>
                        </Zoom>
                    </Col>
                </Row>
                <Row>
                    <Col md={{ span: 6, offset: 3 }} offset={4} className="apply-col">
                        <p className="apply-form-description">Thank you for your interest in Fuerza Online Fitness Coaching!</p>
                        <p className="apply-form-description">Complete this form and I will get in touch with you shortly.</p>
                    </Col>
                </Row>
                <form id="apply-form" ref={formObj} onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md={{ span: 6, offset: 3 }} offset={4} className="apply-col-form">
                            <input {...register('name', { required: true })} className="form-input" type="text" name="name" placeholder="Name" />
                            {errors.name && <p style={{ color: "red", marginTop: "5px", marginBottom: "0px" }}>Name is required.</p>}
                        </Col>
                        <Col md={{ span: 6, offset: 3 }} offset={4} className="apply-col-form">
                            <input {...register('email', { required: true })} className="form-input" type="email" name="email" placeholder="Email" />
                            {errors.email && <p style={{ color: "red", marginTop: "5px", marginBottom: "0px" }}>Email is required.</p>}
                        </Col>
                        <Col md={{ span: 6, offset: 3 }} offset={4} className="apply-col-form">
                            <input {...register('phoneNumber', { required: true })} className="form-input" type="tel" name="phoneNumber" placeholder="Phone Number" />
                            {errors.phoneNumber && <p style={{ color: "red", marginTop: "5px", marginBottom: "0px" }}>Phone number is required.</p>}
                        </Col>
                        <Col md={{ span: 6, offset: 3 }} offset={4} className="apply-col-form">
                            <input {...register('age', { required: true })} className="form-input" type="number" name="age" placeholder="Age" />
                            {errors.age && <p style={{ color: "red", marginTop: "5px", marginBottom: "0px" }}>Age is required.</p>}
                        </Col>
                        <Col md={{ span: 6, offset: 3 }} offset={4} className="apply-col-form">
                            <input id="form-submit" type="submit" value="Submit" />
                        </Col>
                    </Row>
                </form>
            </Container>
        </div>
    );
}

export default ApplySection;